export enum EmpFormsPrivilege {
  MANAGER_VIEW_ONLY = 1,
  MANAGER_APPROVE = 2
}
